import React from 'react';
import { translate } from '../../Services/translation';

const SpecificationDetailsBlasting = ({ blastingDetails, inactive }) => {
  return (
    <table className={'specification-table' + (inactive ? ' specification-table--inactive' : '')}>
      <thead>
        <tr>
          <th>{translate('checkout.cart.specification.specification')}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            {blastingDetails.isPainting
              ? translate('checkout.cart.specification.painting')
              : translate('checkout.cart.specification.blasting')}
            : {blastingDetails.name}
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default SpecificationDetailsBlasting;
